export default {"src":"/_next/static/media/situation-housing.bc12ae8b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};